(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["GN-0029"] && !Shopify.designMode) return;
  try {
    
const grey_dot = "https://cdn.shopify.com/s/files/1/2513/1876/files/GN-0029-DotGrey.png?v=1732102157";
const black_dot = "https://cdn.shopify.com/s/files/1/2513/1876/files/GN-0029-DotBlack.png?v=1732102167";
const grey_arrow = "https://cdn.shopify.com/s/files/1/2513/1876/files/GN-0029-ArrowGrey.png?v=1732102142";
const black_arrow = "https://cdn.shopify.com/s/files/1/2513/1876/files/GN-0029-ArrowBlack.png?v=1732102183";

function setUpSlider(wrapper) {
  const slider = wrapper.querySelector('.gn-0029-slider');
  const slides = wrapper.querySelectorAll('.gn-0029-slider .gn-0029-slide');
  const rightArrow = wrapper.querySelector('.gn-0029-arrow-right');
  const leftArrow = wrapper.querySelector('.gn-0029-arrow-left');
  const dots = wrapper.querySelectorAll('.gn-0029-dots img');

  function computeWidth() {
    const elemWidth = slides[0].clientWidth;
    const sliderWidth = slider.clientWidth;
    const gap = 10;

    return Math.floor(sliderWidth / elemWidth) * (elemWidth + gap);
  }

  let selected_dot = 0;
  slider.addEventListener('scroll', function (e) {
    const img_width = computeWidth();
    const position = Math.ceil(slider.scrollLeft / img_width);

    dots[selected_dot].src = grey_dot;
    dots[position].src = black_dot;
    selected_dot = position;

    if(position === 0) {
      leftArrow.src = grey_arrow;
      rightArrow.src = black_arrow;
    } else if (position === slides.length - 1) {
      leftArrow.src = black_arrow;
      rightArrow.src = grey_arrow;
    } else {
      leftArrow.src = black_arrow;
      rightArrow.src = black_arrow;
    }
  });

  rightArrow.addEventListener('click', function (e) {
    const img_width = computeWidth();
    const position = Math.ceil(slider.scrollLeft / img_width);

    slider.scrollTo((position + 1) * img_width, 0);
  });

  leftArrow.addEventListener('click', function (e) {
    const img_width = computeWidth();
    const position = Math.ceil(slider.scrollLeft / img_width);

    slider.scrollTo((position - 1) * img_width, 0);
  });

  slider.dispatchEvent(new CustomEvent("scroll"));
}

function setUpPopups(slidesWrapper, popupsWrapper) {
  const slides = slidesWrapper.querySelectorAll('.gn-0029-slider .gn-0029-slide');
  const popups = popupsWrapper.querySelectorAll('.gn-0029-popup');
  const overlay = document.querySelector('.gn-0029-popup-overlay');

  overlay.addEventListener('click', (e) => close());

  for(let i = 0; i < popups.length; i++) {
    const image = popups[i].querySelector(".gn-0029-popup-img");
    const videos = popups[i].querySelector(".gn-0029-video-container");
    const videoBtn = popups[i].querySelector(".gn-0029-popup-btn");
    const quitBtn = popups[i].querySelector(".gn-0029-popup-quit");
    const atcBtn = popups[i].querySelector(".gn-0029-atc");
    const inputs = popups[i].querySelectorAll(".gn-0029-checkmark input");

    slides[i].addEventListener("click", () => {
      popups[i].classList.add('active')
      overlay.classList.add('active')
      document.body.classList.add('active');
    });

    //Close
    quitBtn.addEventListener("click", () => close());

    videoBtn.addEventListener('click', (e) => {
      e.preventDefault();
      
      const videoElement = popups[i].querySelector('.gn-0029-video:nth-of-type(1n)');
      const video = popups[i].querySelector('.gn-0029-video:nth-of-type(1n) video');

      if(videoElement && video) {
        videoElement.classList.add('active');

        //Start video
        video.play();
      }

      //Add Active to first video
      image.classList.remove('active');
      videos.classList.add('active');
    })

    atcBtn.addEventListener("click", () => {
      const checkboxes = popups[i].querySelectorAll(".gn-0029-checkmark input");

      // Delay computation variable
      let count = 0;
      for(let i = 0; i <  checkboxes.length; i++) {
        if(checkboxes[i].checked) {
          const id = checkboxes[i].dataset.id;
          setTimeout(() => {
            fetch(`${window.location.origin}/cart/add?id=${id}&quantity=1`)
            .then((response) => {
              fetch(`${window.location.origin}/cart.js`).then(async (response) => {
                const cartContent = await response.json();
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                  bubbles: true,
                  detail: {
                      cart: cartContent,
                      openMiniCart: true
                    }
                }));

                atcBtn.classList.add('active');

                setTimeout(() => atcBtn.classList.remove('active'), 5000);
              })
              .catch(error => console.error(error));
            })
            .catch((error) => {
                console.error("Error:", error);
            });
          }, 500 * count);
          count++;
        }
      }
    });

    inputs.forEach((input) => input.addEventListener('change', (e) => {
      const product = input.parentElement.parentElement;
      product.classList.toggle('active', input.checked);
    }));
  }
}

const moveVideos = () => {
  let videos = document.querySelectorAll('.gn-0029-video');
  videos.forEach((element, i) => {
    const { index } = element.dataset;
    const target = document.querySelector(`.gn-0029-popup[data-index="${index}"] .gn-0029-bullets`)
    const video = element.querySelector('video');

    element.addEventListener('click', (e) => {
      if(video.paused) {
        video.play();
      } else {
        video.pause();
      }
    })

    target.before(element);
  });

  //Create ID to map bullets
  const popups = document.querySelectorAll('.gn-0029-popup')
  popups.forEach((popup) => {
    const videos = popup.querySelectorAll('.gn-0029-video');
    videos.forEach((video, i) => {
      //Append first and last to video
      if(i === 0) {
        video.classList.add('is-first');
      }

      if(i === (videos.length - 1)) {
        video.classList.add('is-last');
      }

      video.dataset.id = i;
    });
  });
}

const createBullets = () => {
  const popups = document.querySelectorAll('.gn-0029-popup');
  popups.forEach((popup) => {
    const parent = document.querySelector('.gn-0029-videos');
    const videos = popup.querySelectorAll('.gn-0029-video');
    const bullets = popup.querySelector('.gn-0029-bullets');

    videos.forEach((video, index) => {
      const bullet = document.createElement('span');
      bullet.classList.add('gn-0029-bullet');
      bullet.classList.toggle('active', index === 0)

      bullets.append(bullet);
    })
  })
}

const videoControls = () => {
  const update = (button, type = 'next') => {
    const index = parseInt(button.dataset.index);
    const id = parseInt(button.dataset.id);

    const parent = document.querySelector(`.gn-0029-popup[data-index="${index}"]`);
    const videos = parent.querySelectorAll('.gn-0029-videos video');
    const prev = parent.querySelector('.gn-0029-video-prev');
    const next = parent.querySelector('.gn-0029-video-next');

    //Update button
    const targetId = type === 'next' ? id + 1 : id - 1;
    prev.dataset.id = type === 'next' ? id + 1 : id - 1;
    next.dataset.id = type === 'next' ? id + 1 : id - 1;

    //Target
    const oldTarget = parent.querySelector(`.gn-0029-video[data-id="${id}"]`);
    const target = parent.querySelector(`.gn-0029-video[data-id="${targetId}"]`);
    const bullets = parent.querySelectorAll('.gn-0029-bullet');

    //Move to next element
    target.scrollIntoView({ 
      behavior: "smooth", 
      block: "center" 
    });

    //Add Active
    oldTarget.classList.remove('active');
    target.classList.add('active');

    //Video
    stopVideos();

    //Play video
    const video = target.querySelector('video');
    video.play();

    //Bullets
    const bulletId = target.dataset.id;
    if(bullets[bulletId]) {
      bullets.forEach((bullet) => bullet.classList.remove('active'))
      bullets[bulletId].classList.add('active')
    }
  }

  const next = document.querySelectorAll('.gn-0029-video-next');
  next.forEach((button) => {
    button.addEventListener('click', (e) => {
      update(button, 'next');
    })
  })

  const prev = document.querySelectorAll('.gn-0029-video-prev');
  prev.forEach((button) => {
    button.addEventListener('click', (e) => {
      update(button, 'prev');
    })
  });

  const mutes = document.querySelectorAll('.gn-0029-video-mute');
  mutes.forEach((button) => button.addEventListener('click', (e) => {
    button.classList.toggle('active');

    const videos = document.querySelectorAll('.gn-0029-video video');
    videos.forEach((video) => {
      video.muted = button.classList.contains('active');
    })
  }))

  const close = document.querySelectorAll('.gn-0029-video-close');
  close.forEach((button) => {
    button.addEventListener('click', (e) => {
      const popups = document.querySelectorAll('.gn-0029-popup');

      popups.forEach((popup) => {
        const image = popup.querySelector('.gn-0029-popup-img');
        const video = popup.querySelector('.gn-0029-video-container');
        const videos = popup.querySelectorAll('.gn-0029-video video');
        const bullets = popup.querySelectorAll('.gn-0029-bullet');
        const prev = popup.querySelector('.gn-0029-video-prev');
        const next = popup.querySelector('.gn-0029-video-next');

        //Video
        videos.forEach((video) => {
          video.pause();
          video.currentTime = 0;
          video.parentElement.classList.remove('active');
        });

        //Reset bullets
        bullets.forEach((bullet) => bullet.classList.remove('active'));
        bullets[0].classList.add('active');

        //Reset position
        videos[0].scrollIntoView();

        //Reset pagination
        prev.dataset.id = 1;
        next.dataset.id = 0;

        //Remove visibiliy
        image.classList.add('active');
        video.classList.remove('active');
      })
    })
  })

  //Intersection
  const targets = document.querySelectorAll('.gn-0029-video');
  const options = {
    rootMargin: '0px',
    threshold: window.innerWidth < 1024 ? 0.15 : 1
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      const target = entry.target;
      const parent = target.parentElement;
      const bulletParent = parent.querySelector('.gn-0029-bullets');
      const bullets = parent.querySelectorAll('.gn-0029-bullets .gn-0029-bullet');

      //Get ID
      const { id } = target.dataset;

      //Find bullet and activate it
      bullets.forEach((bullet) => bullet.classList.remove('active'))
      if(bullets[id]) {
        bullets[id].classList.add('active');
      }

      if (entry.isIntersecting) {
        target.classList.add('active');

        //Find video
        const video = target.querySelector('video');

        //Play it
        video.play();
      } else {
        target.classList.remove('active');

        //Stop all other videos
        const videos = document.querySelectorAll('.gn-0029-video video');
        videos.forEach((video) => video.pause());
      }
    })
  }, options);

  targets.forEach(target => {
    //observer.observe(target)
  })
}

const stopVideos = () => {
  const videos = document.querySelectorAll('.gn-0029-video video');
  //Video
  videos.forEach((video) => {
    video.pause();
    video.currentTime = 0;
  });
}

const close = () => {
  const overlay = document.querySelector('.gn-0029-popup-overlay');
  overlay.classList.remove('active');

  //Popups
  const popups = document.querySelectorAll('.gn-0029-popup');
  popups.forEach((popup) => popup.classList.remove('active'));

  //Remove Body
  document.body.classList.remove('active');

  //Stop Videos
  stopVideos();
}

document.addEventListener("DOMContentLoaded", async () => {
  document.body.classList.add('as-gn-0029');

  await moveVideos();

  const slidesWrapper = document.querySelector('.gn-0029-wrapper');
  setUpSlider(slidesWrapper);

  const popupsWrapper = document.querySelector('.gn-0029-popups');
  setUpPopups(slidesWrapper, popupsWrapper);

  //Bullets
  createBullets();

  //Create Video Controls
  videoControls();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geolizr-countdown"] && !Shopify.designMode) return;
  try {
    

  class GeolizrCountdown {
          constructor(config, countryCode) {
            this.country = countryCode.toUpperCase();
            this.active = true;
            this.init(config);
          }
      
          init(config) {
            this.visible = false;
            this.editor = false;
            this.config = config;
            this.endDate = config.endDates["*"];
            if(typeof config.endDates[this.country] !== "undefined") {
              this.endDate = config.endDates[this.country];
              this.usedCountry = this.country;
            }
            this.endTimestamp = new Date(this.endDate).getTime();
            this.section = document.querySelector(`#shopify-section-${this.config.section_id}`);
            this.element = document.querySelector(`#shopify-section-${this.config.section_id} span.timer`);
            this.endTimestamp = this.getEndTimeStamp();

            // this.tick();
   
            this.checkActivateStartDate();
          }

          /***
           * Zeigt den Countdown an und fügt eine zusätzliche Startinfo hinzu.
           * Diese Methode wird verwendet, wenn ein Startdatum existiert, um den Countdown
           * im Editor-Modus mit einem Hinweis anzuzeigen.
           *
           * @return void
           **************************/
          showWithStart() {
              this.show(); // Zeigt den Countdown an
              let wrapper = document.getElementById('geolizr-countdown-wrapper');
              let info = document.createElement('div'); // Erstellt ein neues div-Element
              info.classList.add('start-info'); // Fügt eine CSS-Klasse hinzu
              info.innerHTML = 'show: ' + this.config.activate_start; // Fügt den Hinweistext ein
              wrapper.appendChild(info); // Hängt das Element in den Wrapper ein
          }
          
          /***
           * Zeigt den Countdown an, indem das zugehörige Wrapper-Element sichtbar gemacht wird.
           *
           * @return void
           **************************/
          show() {
              let wrapper = document.getElementById('geolizr-countdown-wrapper');
              this.visible = true; // Setzt die Sichtbarkeit auf sichtbar
              wrapper.style.display = 'block'; // Setzt den Stil des Wrappers auf "block", um ihn anzuzeigen
          }
          
          /***
           * Versteckt den Countdown, indem das zugehörige Wrapper-Element ausgeblendet wird.
           *
           * @return void
           **************************/
          hide() {
              let wrapper = document.getElementById('geolizr-countdown-wrapper');
              this.visible = false; // Setzt die Sichtbarkeit auf unsichtbar
              wrapper.style.display = 'none'; // Setzt den Stil des Wrappers auf "none", um ihn zu verstecken
          }


          /***
           * Überprüft, ob der Countdown abgelaufen ist oder kein Datum zur Anzeige relevant ist.
           * 
           * Diese Methode berechnet die verbleibende Zeit basierend auf dem Endzeitstempel und 
           * prüft, ob der Countdown noch angezeigt werden soll. Die Logik berücksichtigt auch 
           * die Konfiguration zur Ausblendung bei Ablauf.
           *
           * @return {boolean} - Gibt `true` zurück, wenn der Countdown abgelaufen ist oder keine relevanten Daten vorliegen.
           **************************/
          isExpiredOrNoDateShow() {
              // if expireHide off, then it's always relevant
              if (this.config.expiredHide === false) return false;
            
              let now = new Date().getTime(); // Aktuelle Zeit in Millisekunden
              let left = this.getEndTimeStamp() - now; // Verbleibende Zeit berechnen

              let template = this.getExpiredText();
              let variables = {};
                            debugger;

              if(left > 0) {
                // Berechnung der einzelnen Zeitkomponenten: Tage, Stunden, Minuten, Sekunden
                variables = this.getTimerVariables();            
                template = this.getTimerText(); // Timer-Textvorlage abrufen
              }
          
              if (template.indexOf("{countdown") > 0 && this.config.expiredHide === true && left >= 0) {
                  return false; // Countdown noch nicht abgelaufen
              }
          
              let isRelevant = false;
          
              // Prüfen, ob eine der Variablen in der Vorlage genutzt wird und positiv ist
              Object.keys(variables).forEach((key) => {
                  if (template.includes(`{${key}`) && variables[key] > 0) {
                      isRelevant = true;
                  }
              });
          
              // Wenn keine relevante Variable vorhanden ist und expiredHide true ist
              if (!isRelevant && this.config.expiredHide === true) {
                  return true; // Countdown ausblenden
              }
          
              return false; // Countdown bleibt sichtbar
          }
          
          /***
           * Überprüft die Start- und Enddaten des Countdowns und steuert dessen Anzeige.
           * 
           * Diese Methode prüft, ob der Countdown aktiv sein sollte, basierend auf 
           * einem Startdatum (`activate_start`) und einem Enddatum (`activate_end`).
           * Zusätzlich wird die Singular-/Plural-Logik für verschiedene Zeiteinheiten gesetzt.
           *
           * @return void
           **************************/
          checkActivateStartDate() {
              let activateStartDate = this.config.activateStartDate; // Startdatum aus den Einstellungen
              let activateEndDate = this.config.activateEndDate; // Enddatum aus den Einstellungen
              let singlePluralStrings = this.config.singlePluralString; // Singular/Plural-Strings
              this.pluralSingle = {}; // Initialisierung des Objekts für Singular/Plural-Begriffe
          
              let textIndex = ["d", "H", "m", "s"]; // Zeitindizes: Tage, Stunden, Minuten, Sekunden
              let useIndex = 0;
          
              // Parsing der Singular/Plural-Werte und Zuweisung zu den Zeitindizes
              singlePluralStrings.split(',').forEach(pair => {
                  let [plural, singular] = pair.split('/').map(value => value.trim());
                  if (plural && singular && typeof textIndex[useIndex] !== "undefined") {
                      this.pluralSingle[textIndex[useIndex]] = { plural, singular };
                  }
                  useIndex++;
              });
          
              let now = new Date(); // Aktuelle Zeit
              let nowTime = now.getTime();
              let left = this.getEndTimeStamp() - nowTime;
          
              // Countdown ausblenden, wenn er abgelaufen ist oder irrelevant
              if (this.isExpiredOrNoDateShow()) {
                  clearInterval(this.timer); // Timer stoppen
                  this.visible = false;
                  this.active = false;
                  return;
              }
          
              // Prüfung des Startdatums
              if (activateStartDate === "none" || activateStartDate === "") {
                  this.show(); // Countdown sofort anzeigen
              } else {
                  let activeStart = new Date(activateStartDate);
                  if (isNaN(activeStart.getTime())) {
                      console.log("wrong datetime for start, show the countdown");
                      this.show(); // Bei ungültigem Startdatum anzeigen
                  } else if (activeStart <= now) {
                      this.show(); // Countdown anzeigen, wenn das Startdatum erreicht wurde
                  } else if (Shopify.designMode) {
                      this.showWithStart(); // Im Editor-Modus zusätzliche Info anzeigen
                  }
              }
          
              // Prüfung des Enddatums
              if (activateEndDate !== "none" && activateEndDate !== "") {
                  let activeEnd = new Date(activateEndDate);
                  if (activeEnd && !isNaN(activeEnd.getTime()) && activeEnd <= now) {
                      this.hide(); // Countdown ausblenden, wenn Enddatum erreicht wurde
                  }
              }
          }
     
          /***
           * Rendert den gegebenen HTML-Text in das Timer-Element.
           * 
           * Diese Methode aktualisiert das Timer-Element innerhalb des Shopify-Abschnitts
           * mit neuem HTML-Inhalt und fügt der übergeordneten Sektion eine CSS-Klasse hinzu,
           * um sie sichtbar zu machen.
           * 
           * @param {string} htmlText - Der HTML-Text, der in das Timer-Element eingefügt wird.
           * @return void
           **************************/
          render(htmlText) {
              // Holt das Timer-Element im aktuellen Abschnitt
              this.element = document.querySelector(`#shopify-section-${this.config.section_id} span.timer`);
              this.element.innerHTML = htmlText; // Setzt den neuen HTML-Text in das Element
          
              // Fügt der Sektion die CSS-Klasse 'show' hinzu, falls sie existiert
              if (this.section) {
                  this.section.classList.add("show");
              }
          }
          
          /***
           * Holt den Textinhalt des Timer-Elements aus dem DOM.
           * 
           * Diese Methode sucht innerhalb des Shopify-Abschnitts nach dem Element,
           * das die Timer-Textvorlage enthält, und gibt dessen Inhalt zurück.
           * 
           * @return {string} - Der Textinhalt der Timer-Textvorlage.
           **************************/
          getTimerText() {
              // Holt das Element mit der Klasse 'countdown-timerText' im aktuellen Abschnitt
              let element = document.querySelector(`#shopify-section-${this.config.section_id} .countdown-timerText`);
              return element.innerHTML; // Gibt den Textinhalt des Elements zurück
          }

          getTimerVariables() {
              let now = new Date();
              let nowTime = now.getTime();
              let left = this.getEndTimeStamp() - nowTime;
              let days = Math.floor(left / (1000 * 60 * 60 * 24));
              let hours = Math.floor((left % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              let fullHours = hours + days * 24;
              let minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
              let fullMinutes = minutes + fullHours * 60;
              let seconds = Math.floor((left % (1000 * 60)) / 1000);
          
              // Variablen für die Template-Verarbeitung vorbereiten
              return {
                  days,
                  hours,
                  fullHours,
                  fullMinutes,
                  minutes,
                  seconds,
                  dayString: days,
                  hourString: fullHours,
                  minuteString: minutes,
                  secondString: seconds,
                  countdown: seconds
              };
          }

          /***
           * Gibt den Expire Text aus der Config zurück
           * @return {string} - Der Textinhalt der Timer-Expire-Vorlage.
           **************************/
          getExpiredText() {
            return this.config.expired;
          }


          /***
           * Liefert Parser-Objekte für die Template-Parsing-Logik.
           *
           * Diese Methode definiert reguläre Ausdrücke (Regex) und zugehörige Callbacks,
           * um Platzhalter in einem Template zu verarbeiten. Sie unterstützt das Parsen von
           * Singular-/Plural-Strings sowie Countdown-Elementen.
           *
           * @return {object} - Ein Objekt mit Parsern, bestehend aus Regex und Callback-Funktionen.
           **************************/
          getParserObjects() {
              return {
                  parseStrings: {
                      // Regex zum Verarbeiten von Singular/Plural-Strings in der Form: {key | singular: "X" | plural: "Y"}
                      regex: /\{(\w+)\s*\|\s*singular:\s*["'](.*?)["']\s*\|\s*plural:\s*["'](.*?)["']\s*\}/g,
                      callback: (args, variables) => {
                          const [_, key, singular, plural] = args; // Extrahiere die Regex-Gruppen
                          const value = variables[key];
                          if (typeof value === "undefined") return "";
                          const valCount = Number(value);
                          return `${valCount} ${valCount === 1 ? singular : plural}`;
                      },
                  },
                  countdown: {
                      // Regex zum Verarbeiten von Countdown-Elementen in der Form: {countdown | elements: "X,Y,Z"}
                      regex: /\{countdown\s*\|\s*elements:\s*["'](.*?)["']\s*\}/g,
                      callback: (args, variables) => {
                          const [_, elements] = args; // Extrahiere die Regex-Gruppen
                          const elementList = elements.split(",").map(e => e.trim()); // Elemente in Array umwandeln
          
                          // Logik für unterschiedliche Countdown-Elemente
                          if (variables.fullHours >= 48 && (elementList.includes("days") || elementList.includes("d"))) {
                              return `${variables.days} ${this.pluralSingle.d.plural}`;
                          }
                          if (variables.fullHours < 48 && variables.fullHours >= 2 && (elementList.includes("hours") || elementList.includes("H"))) {
                              return `${variables.fullHours} ${this.pluralSingle.H.plural}`;
                          }
                          if (variables.fullHours < 2 && variables.fullMinutes >= 1 && (elementList.includes("minutes") || elementList.includes("m"))) {
                              const minuteText = parseInt(variables.fullMinutes) === 1 ? this.pluralSingle.m.singular : this.pluralSingle.m.plural;
                              return `${variables.fullMinutes} ${minuteText}`;
                          }
                          if (variables.minutes < 1 && (elementList.includes("seconds") || elementList.includes("s"))) {
                              const secondText = parseInt(variables.seconds) === 1 ? this.pluralSingle.s.singular : this.pluralSingle.s.plural;
                              return `${variables.seconds} ${secondText}`;
                          }
          
                          return "0 " + this.pluralSingle.s.plural; // Fallback-Wert für Sekunden
                      },
                  },
              };
          }
          
          /***
           * Parst eine Vorlage (Template) mit gegebenen Variablen.
           *
           * Diese Methode ersetzt Platzhalter in einem Template-String durch die zugehörigen
           * Werte aus dem Variablen-Objekt. Zusätzlich werden die definierten Parser-Objekte
           * verwendet, um komplexere Platzhalter zu verarbeiten.
           *
           * @param {string} template - Der zu parsende Template-String.
           * @param {object} variables - Ein Objekt mit Werten für die Platzhalter.
           * @return {string} - Der fertige, geparste String.
           **************************/
          parseTemplate(template, variables) {
              const parsers = this.getParserObjects(); // Parser-Objekte holen
          
              // Platzhalter im Format ${key} durch die Variablenwerte ersetzen
              let result = template.replace(/\$\{(\w+)\}/g, (_, key) => {
                return Object.prototype.hasOwnProperty.call(variables, key)
                      ? variables[key]
                      : "";
              });
          
              // Spezifische Parser anwenden
              for (const parserKey in parsers) {
                  const parser = parsers[parserKey];
                  result = result.replace(parser.regex, (...args) => {
                      console.log("Callback args:", args);
                      console.log("Variables:", variables);
                      return parser.callback(args, variables); // Callback-Funktion ausführen
                  });
              }
          
              return result; // Geparster String zurückgeben
          }
          
          /***
           * Holt den Endzeitstempel für den Countdown aus den Konfigurationsdaten.
           *
           * Diese Methode liest die Endzeiten aus dem DOM und analysiert sie entweder
           * mit JSON5 (falls verfügbar) oder normalem JSON. Sie ermittelt das spezifische
           * Enddatum für das aktuelle Land und berechnet den zugehörigen Zeitstempel.
           *
           * @return {number} - Der Endzeitstempel in Millisekunden seit 1970 (Unix-Zeit).
           **************************/
          getEndTimeStamp() {
              // Enddaten-Element aus dem DOM holen
              let element = document.querySelector(`#shopify-section-${this.config.section_id} .countdown-endDates`);
              
              // JSON-Daten aus dem Element parsen
              if (typeof JSON5 !== "undefined") {
                  this.config.endDates = JSON5.parse(element.innerHTML); // JSON5 für flexibles Parsing
              } else {
                  this.config.endDates = JSON.parse(element.innerHTML); // Standard-JSON
              }
          
              // Enddatum für alle Länder oder spezifisches Land festlegen
              this.endDate = this.config.endDates["*"];
              if (typeof this.config.endDates[this.country] !== "undefined") {
                  this.endDate = this.config.endDates[this.country];
                  this.usedCountry = this.country;
              }
          
              // Endzeitstempel berechnen und zurückgeben
              this.endTimestamp = new Date(this.endDate).getTime();
              return this.endTimestamp;
          }
          
          /***
           * Aktualisiert den Countdown-Timer, berechnet die verbleibende Zeit und rendert sie.
           *
           * Diese Methode berechnet die verbleibende Zeit bis zum Endzeitpunkt und aktualisiert 
           * den Countdown-Timer. Wenn die Zeit abgelaufen ist, wird der Timer ausgeblendet oder 
           * ein Ablauf-Text angezeigt, je nach Konfiguration.
           *
           * @return void
           **************************/
          tick() {
              if (this.active == false) { 
                  this.hide(); // Blendet den Countdown aus, wenn er inaktiv ist
                  return;
              } else {
                  this.show(); // Zeigt den Countdown an, wenn er aktiv ist
              }
          
              let now = new Date().getTime(); // Aktuelle Zeit in Millisekunden
              let left = this.endTimestamp - now; // Verbleibende Zeit berechnen
          
              let template = this.getExpiredText();
              let variables = {};
              if(left > 0) {
                // Berechnung der einzelnen Zeitkomponenten: Tage, Stunden, Minuten, Sekunden
                variables = this.getTimerVariables();
                template = this.getTimerText(); // Timer-Textvorlage abrufen
              }
          
              // Timer-Text durch Template-Verarbeitung generieren und anzeigen
              const evaluatedString = this.parseTemplate(template, variables);
              this.render(evaluatedString);
          
              // Countdown ausblenden, wenn die Zeit abgelaufen ist
              if (left < 0 && this.config.expiredHide === true) {
                  this.hide();
                  clearInterval(this.timer); // Timer stoppen
          
                  if (this.config.expiredHide === true) {
                      this.visible = false;
                      this.active = false; // Countdown als inaktiv markieren
                  } else {
                      this.render(this.config.expired); // Ablauftext anzeigen
                  }
              }
          }
          
          /***
           * Startet den Countdown und aktualisiert ihn jede Sekunde.
           *
           * Diese Methode ruft die `tick()`-Methode auf, um den Countdown zu initialisieren, 
           * und setzt ein Intervall, um den Countdown jede Sekunde zu aktualisieren.
           *
           * @return void
           **************************/
          execute() {
              this.tick(); // Initiale Aktualisierung des Countdowns
              this.timer = setInterval(() => { 
                  this.tick(); // Aktualisiert den Countdown jede Sekunde
              }, 1000);
          }
      }

    document.addEventListener('geolizr.init', () => {
    if(typeof Geolizr.countdown == "undefined") {
       
        /**************************************************************************************
         *  CONFIG and init countdown 
         **************************************************************************************/
        try {
            Geolizr.CountDownError = function(message) {
              var newDiv = document.createElement("div");
              let errorElements = document.querySelectorAll(`.geolizr-countdown-error`);
              for (let i = 0; i < errorElements.length; i++) {
                newDiv = document.createElement("div");
                newDiv.innerHTML = message;
                errorElements[i].appendChild(newDiv); 
                errorElements[i].parentElement.classList.add("show");
              }
              let wrapper = document.getElementById('geolizr-countdown-wrapper');
              this.visible = true;
              wrapper.style.display = 'block';
          }

          let element = document.querySelector('#shopify-section-' + window.section_id + ' .countdown-endDates');
          if(typeof JSON5 !== "undefined") {
            geolizrCountdownConfig.endDates = JSON5.parse(element.innerHTML);
          } else {
            geolizrCountdownConfig.endDates = JSON.parse(element.innerHTML);
          }
  
          let countryDetected = sessionStorage.getItem('geolizr-cachedData');
          if(typeof countryDetected !== "undefined" && countryDetected !== null) {
            Geolizr.countdown = new GeolizrCountdown(geolizrCountdownConfig, countryDetected);
            Geolizr.countdown.execute();
          } else if(Shopify.designMode) {
            Geolizr.countdown = new GeolizrCountdown(geolizrCountdownConfig, editor_test_country);
            Geolizr.countdown.editor = true;
            Geolizr.countdown.active = countdownEnable;
            Geolizr.countdown.execute();
            document.addEventListener('shopify:section:load', (e) => {
              if(e.detail.sectionId == "geolizr-countdown") {
                  let configElement = document.querySelector(`#shopify-section-${Geolizr.countdown.config.section_id} .countdown-config`);
                  Geolizr.countdown.active = configElement.dataset.active === "true";
                  Geolizr.countdown.show();
                  Geolizr.countdown.execute();
                  document.querySelector('#shopify-section-geolizr-countdown').style.display = "block";
                }
            });
          } else {
            if(typeof Geolizr !== "undefined") {
              Geolizr.getGeoData((data) => {
                sessionStorage.setItem('geolizr-cachedData', data.country.code);
                Geolizr.countdown = new GeolizrCountdown(geolizrCountdownConfig, data.country.code);
                Geolizr.countdown.execute();
              });
            }       
          }
        } catch (err) {
          if(Shopify.designMode === true) {
            Geolizr.CountDownError("Geolizr error: " + err.message);
          }
          console.error("Geolizr error: ", err)
        }
    } else {
      let err = "double defined in " + Geolizr.countdown.config.section_id;
      if(Geolizr.countdown.editor === true) {
        Geolizr.countdown.error(err);
      }
      console.error("Geolizr error: ", err)
    }

    });

  } catch(e) { console.error(e); }
})();
})();
